import { ReactElement } from "react";

export function Overlay(props: {
  show: boolean;
  text: string;
}): ReactElement {
  return (
    <div
      className={`${
        props.show ? "" : "hidden"
      } fixed flex flex-col items-center justify-center w-full h-full top-0 left-0 right-0 bottom-0 bg-gray-500/50 z-50 cursor-pointer`}
    >
      <span className="text-white text-2xl font-bold">{props.text}</span>
    </div>
  );
}
